
import React from 'react';
import Base from './Base';
import config from './config';

/**
 * Section element with vertical padding
 */

const Section = (props) => {
  const { scale } = config;

  return (
    <Base
      {...props}
      tagName="section"
      className="Section"
      baseStyle={{
        paddingTop: scale[4],
        paddingBottom: scale[4],
      }}
    />
  );
};

export default Section;

